import styled from "styled-components"

export const Component = styled.div<{ $k?: number }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  padding: 0 12px 6px;
  border-bottom: 1px solid #ccc;

  @media (max-width: 340px) {
    flex-direction: column;
    padding-bottom: 24px;
  }

  opacity: 0;
  ${({ $k, theme }) =>
    theme.animations.types.fadeLeft +
    theme.animations.durations.main +
    theme.animations.delays.main($k)}
`

export const TicketInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  @media (max-width: 340px) {
    align-self: flex-start;
  }
`

export const TicketName = styled.span`
  font-size: 16px;
  font-weight: 900;
  color: ${({ theme }) => theme.colors.black.secondary};
`

export const TicketPrice = styled.span`
  font-size: 16px;
  color: #6b7280;
`

export const TicketDescription = styled.span`
  font-size: 13px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.black.secondary};
  margin-top: -2px;
`

export const Quantity = styled.div<{ $saledOut?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  ${({ $saledOut }) =>
    $saledOut ? "width: 100%; max-width: 120px; text-align: center;" : ""}

  span {
    line-height: 100%;
    line-height: 24px;
  }
`

export const QntControl = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: ${({ theme }) => theme.bp.small}px) {
    flex-direction: column-reverse;

    &:has(> span) {
      padding-top: 12px;
    }
  }
`

export const ControlsButtonsArea = styled.div`
  display: flex;
  align-items: center;

  span {
    min-width: 32px;
    text-align: center;
    margin: 0 8px;
  }
`

export const Control = styled.button<{ $disabled?: boolean }>`
  border: none;
  outline: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  background: none;
  opacity: ${({ $disabled }) => ($disabled ? 0.38 : 1)};
  transition: opacity 0.25s, background-color 0.2s;
  min-width: 44px;
  min-height: 44px;
  padding: 10px;
  border-radius: 999px;

  img {
    width: 24px;
    height: 24px;
    border-radius: 24px;
  }

  &:not(:disabled):hover {
    background-color: rgba(0, 97, 230, 0.08);
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.blue.main};
    outline-offset: 2px;
  }
`
